import { Bell, Grid2X2, X } from "lucide-react";
import { useAdminDetail } from '@/hooks/useAdminDetail';
import BestafLogo from "./BestafLogo";

export const Topbar = ({ isOpen, open, close }: { isOpen?: boolean, open: () => void, close: () => void }) => {
    const { adminLogin } = useAdminDetail();

    const getInitial = () =>
        adminLogin?.name?.substring(0, 2).toUpperCase();

    return (
        <section className="fixed inset-x-0 top-0 z-40 grid h-20 grid-cols-12 items-center bg-white px-4 shadow-sm">
            <div className="md:col-span-3 col-span-1">
                <div className="flex items-center space-x-2">
                    <div className="md:block hidden"><BestafLogo /></div>
                    <div className="md:hidden block">
                        {!isOpen ? <Grid2X2 onClick={open} /> : <X onClick={close} />}
                    </div>
                </div>
            </div>
            <div className="col-span-5 ">

            </div>
            <div className="md:col-span-4  col-span-6 pr-4">
                <div className="flex items-center justify-end space-x-4">
                    <div className="grid size-10 place-content-center rounded-full bg-muted">
                        <Bell size={16} className="text-primary-500" />
                    </div>
                    {adminLogin.image ? (
                        <div className="size-10 rounded-full">
                            <img src={adminLogin.image} alt="ProfileImage" className="object-cover size-10  rounded-full" />
                        </div>

                    ) : (
                        <div className="grid size-10 place-content-center rounded-full bg-muted text-primary-500">
                            {getInitial()}
                        </div>
                    )}
                    <div className="flex flex-col text-sm">
                        <h1 className="font-semibold">
                            {" "}
                            {adminLogin?.name ?? ""}
                        </h1>
                        <h2 className="text-muted-foreground">
                            {adminLogin.role ?? ""}
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    );
};
